export const popUpStyles = {
  popupContainer: {
    width: ['350px', '450px'],
    height: '360px',
  },
  secondBorderSection: {
    width: '95%',
    margin: 'auto',
    height: '340px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  submitButton: {
    width: '100%',
  },
};

export const scrollBoxStyles = {
  scrollBoxContainer: {
    p: 3,
    width: ['350px', '450px'],
  },
  headingContainer: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
  subheadline: {
    mt: 2,
  },
  formContainer: {
    width: ['300px', '375px'],
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    p: 0,
    mt: 3,
  },
  radioButtonContainer: {
    mt: 2,
    mb: 3,
  },
  radioText: {
    fontWeight: 'medium',
  },
  submitButton: {
    width: '100%',
  },
};
